module.exports = __webpack_public_path__ + "img/centro-imagenes-quilmes.f6287ef6.jpg";